import { GRONDVERZET_USERNAMES } from '@/utils/grondverzet/grondverzetAccess'

const exportItems = [
  {
    group: 'TerraIndex',
    options: [
      {
        name: 'TerraIndex',
        exportTypeName: 'TerraIndex',
        exportServerIdentifier: 'Export_FIELD_XML_v1_0_0',
        extension: 'ti',
        Measurementpoints: true,
        AnalysisSamples: true,
        WaterSamples: true,
        AirSamples: true,
        useCompression: true
      }
    ]
  },
  {
    group: 'TerraIndex V2',
    terraIndexOnly: true,
    options: [
      {
        name: 'TerraIndex_V2',
        exportTypeName: 'TerraIndex',
        backend: 'importExportOrchestrator',
        outputFormatType: 'Classic',
        outputVersion: '1.0',
        extension: 'ti',
        useCompression: true,
        Measurementpoints: true,
        AnalysisSamples: true,
        WaterSamples: true,
        AirSamples: true
      }
    ]
  },
  {
    group: 'SIKB',
    options: [
      {
        name: 'SIKB14_4',
        exportTypeName: 'SIKB_14_4_0',
        exportServerIdentifier: 'Export_IMSIKB_v14_3_0',
        Measurementpoints: true,
        AnalysisSamples: true,
        WaterSamples: true,
        AirSamples: true
      },
      {
        name: 'SIKB14_7',
        exportTypeName: 'SIKB_14_7_0',
        exportServerIdentifier: 'Export_IMSIKB_v14_7_0',
        Measurementpoints: true,
        AnalysisSamples: true,
        WaterSamples: true,
        AirSamples: true
      },
      {
        name: 'SIKB14_8',
        exportTypeName: 'SIKB_14_8_0',
        exportServerIdentifier: 'Export_IMSIKB_v14_8_0',
        Measurementpoints: true,
        AnalysisSamples: true,
        WaterSamples: true,
        AirSamples: true
      },
      {
        name: 'SIKB14_9',
        exportTypeName: 'SIKB_14_9_0',
        exportServerIdentifier: 'Export_IMSIKB_v14_9_0',
        preExportChecks: ['SIKBValidationSelector', 'BROSADIdCheck', 'BROSADCorrectionReason', 'NEN5104Normalization'],
        Measurementpoints: true,
        AnalysisSamples: true,
        WaterSamples: true,
        AirSamples: true
      }
    ]
  },
  {
    group: 'SIKB V2',
    terraIndexOnly: true,
    options: [
      {
        name: 'SIKB14_4_V2',
        exportTypeName: 'SIKB_14_4_0',
        backend: 'importExportOrchestrator',
        outputFormatType: 'SIKB_XML',
        outputVersion: '14.4.0',
        Measurementpoints: true,
        AnalysisSamples: true,
        WaterSamples: true,
        AirSamples: true
      },
      {
        name: 'SIKB14_7_V2',
        exportTypeName: 'SIKB_14_7_0',
        backend: 'importExportOrchestrator',
        outputFormatType: 'SIKB_XML',
        outputVersion: '14.7.0',
        Measurementpoints: true,
        AnalysisSamples: true,
        WaterSamples: true,
        AirSamples: true
      },
      {
        name: 'SIKB14_8_V2',
        exportTypeName: 'SIKB_14_8_0',
        backend: 'importExportOrchestrator',
        outputFormatType: 'SIKB_XML',
        outputVersion: '14.8.0',
        Measurementpoints: true,
        AnalysisSamples: true,
        WaterSamples: true,
        AirSamples: true
      },
      {
        name: 'SIKB14_9_V2',
        exportTypeName: 'SIKB_14_9_0',
        backend: 'importExportOrchestrator',
        outputFormatType: 'SIKB_XML',
        outputVersion: '14.9.0',
        preExportChecks: ['SIKBValidationSelector', 'BROSADIdCheck', 'BROSADCorrectionReason'],
        Measurementpoints: true,
        AnalysisSamples: true,
        WaterSamples: true,
        AirSamples: true
      }
    ]
  },
  {
    group: 'Internal',
    terraIndexOnly: true,
    options: [
      {
        name: 'Streamline_Export',
        exportTypeName: 'Streamline_Export',
        exportServerIdentifier: 'Export_Streamline_Single_JSON',
        extension: 'json',
        Measurementpoints: true,
        AnalysisSamples: true,
        WaterSamples: true
      },
      {
        name: 'Streamline_Report_Dataset',
        exportTypeName: 'Streamline_Report_Dataset',
        exportServerIdentifier: 'Export_Streamline_Presentation_Single_JSON',
        extension: 'json',
        Measurementpoints: true,
        AnalysisSamples: true,
        WaterSamples: true
      }
    ]
  },
  {
    group: 'Internal V2',
    terraIndexOnly: true,
    options: [
      {
        name: 'Streamline_Export_V2',
        exportTypeName: 'Streamline_Export',
        exportServerIdentifier: 'Export_Streamline_Single_JSON',
        backend: 'importExportOrchestrator',
        outputFormatType: 'Streamline',
        outputVersion: '1.0',
        mergeIntoSingleJson: true,
        extension: 'json',
        Measurementpoints: true,
        AnalysisSamples: true,
        WaterSamples: true
      },
      {
        name: 'Streamline_Report_Dataset_V2',
        exportTypeName: 'Streamline_Report_Dataset',
        backend: 'importExportOrchestrator',
        outputFormatType: 'StreamlinePresentation',
        outputVersion: '1.0',
        mergeIntoSingleJson: true,
        extension: 'json',
        Measurementpoints: true,
        AnalysisSamples: true,
        WaterSamples: true
      }
    ]
  },
  {
    group: 'Mistral',
    options: [
      {
        name: 'Mistral_8_9',
        exportTypeName: 'Mistral_8_9',
        exportServerIdentifier: 'Export_OVAM_MISTRAL2_v8_4_0',
        Measurementpoints: true,
        AnalysisSamples: true,
        WaterSamples: true,
        AirSamples: true
      },
      {
        name: 'Mistral_9_0',
        exportTypeName: 'Mistral_9_0',
        exportServerIdentifier: 'Export_OVAM_MISTRAL2_v9_0_0',
        // Same audience as the Grondverzet button
        terraIndexOnly: true,
        allowedUsernames: GRONDVERZET_USERNAMES,
        Measurementpoints: true,
        AnalysisSamples: true,
        WaterSamples: true,
        AirSamples: true
      }
    ]
  },
  {
    group: 'BRO',
    options: [
      {
        name: 'BROBHR',
        exportTypeName: 'BRO_BHR_GT_IMBRO_A',
        exportServerIdentifier: 'Export_DELPHI_BRO_BHR_GT_BMB',
        extension: 'zip',
        Measurementpoints: true
      },
      {
        name: 'BROGMW',
        exportTypeName: 'BRO_GMW',
        exportServerIdentifier: 'Export_BRO_GMW',
        extension: 'zip',
        Measurementpoints: true
      },
      {
        name: 'BROBHRGT',
        exportTypeName: 'BRO_BHR_GT',
        exportServerIdentifier: 'Export_BRO_BHR_GT',
        extension: 'zip',
        Measurementpoints: true
      },
      {
        name: 'BROGAR',
        exportTypeName: 'BRO_GAR',
        exportServerIdentifier: 'Export_BRO_GAR',
        extension: 'zip',
        Measurementpoints: true,
        WaterSamples: true
      },
      {
        name: 'BROSAD_IMBRO_Registration',
        exportTypeName: 'BRO_SAD_IMBRO',
        exportServerIdentifier: 'Export_BRO_SAD_IMBRO_Registration',
        preExportChecks: ['BROSADIdCheck', 'NEN5104Normalization'],
        Measurementpoints: true,
        AnalysisSamples: true,
        WaterSamples: true,
        AirSamples: true
      },
      {
        name: 'BROSAD_IMBRO_Correction',
        exportTypeName: 'BRO_SAD_IMBRO_Correctie',
        exportServerIdentifier: 'Export_BRO_SAD_IMBRO_Correction',
        preExportChecks: ['BROSADIdCheck', 'BROSADCorrectionReason', 'NEN5104Normalization'],
        Measurementpoints: true,
        AnalysisSamples: true,
        WaterSamples: true,
        AirSamples: true
      },
      {
        name: 'BROSAD_IMBROA_Registration',
        exportTypeName: 'BRO_SAD_IMBRO_A',
        exportServerIdentifier: 'Export_BRO_SAD_IMBROA_Registration',
        preExportChecks: ['BROSADIdCheck', 'NEN5104Normalization'],
        Measurementpoints: true,
        AnalysisSamples: true,
        WaterSamples: true,
        AirSamples: true
      },
      {
        name: 'BROSAD_IMBROA_Correction',
        exportTypeName: 'BRO_SAD_IMBRO_A_Correctie',
        exportServerIdentifier: 'Export_BRO_SAD_IMBROA_Correction',
        preExportChecks: ['BROSADIdCheck', 'BROSADCorrectionReason', 'NEN5104Normalization'],
        Measurementpoints: true,
        AnalysisSamples: true,
        WaterSamples: true,
        AirSamples: true
      }
    ]
  },
  {
    group: 'BRO V2',
    terraIndexOnly: true,
    options: [
      {
        name: 'BROBHR_V2',
        exportTypeName: 'BRO_BHR_GT_IMBRO_A',
        backend: 'importExportOrchestrator',
        outputFormatType: 'BRO_GT_IMBROA_XML',
        outputVersion: '2.1',
        extension: 'zip',
        useCompression: true,
        Measurementpoints: true
      },
      {
        name: 'BROGMW_V2',
        exportTypeName: 'BRO_GMW',
        backend: 'importExportOrchestrator',
        outputFormatType: 'BRO_GMW_XML',
        outputVersion: '1.1',
        extension: 'zip',
        useCompression: true,
        Measurementpoints: true
      },
      {
        name: 'BROBHRGT_V2',
        exportTypeName: 'BRO_BHR_GT',
        backend: 'importExportOrchestrator',
        outputFormatType: 'BRO_GT_XML',
        outputVersion: '2.1',
        extension: 'zip',
        useCompression: true,
        Measurementpoints: true
      },
      {
        name: 'BROGAR_V2',
        exportTypeName: 'BRO_GAR',
        backend: 'importExportOrchestrator',
        outputFormatType: 'BRO_GAR_XML',
        outputVersion: '1.0',
        extension: 'zip',
        useCompression: true,
        Measurementpoints: true,
        WaterSamples: true
      },
      {
        name: 'BROSAD_IMBRO_Registration_V2',
        exportTypeName: 'BRO_SAD_IMBRO',
        backend: 'importExportOrchestrator',
        outputFormatType: 'BRO_SAD_IMBRO_XML_Registration',
        outputVersion: '1.0',
        preExportChecks: ['BROSADIdCheck'],
        Measurementpoints: true,
        AnalysisSamples: true,
        WaterSamples: true,
        AirSamples: true
      },
      {
        name: 'BROSAD_IMBRO_Correction_V2',
        exportTypeName: 'BRO_SAD_IMBRO_Correctie',
        backend: 'importExportOrchestrator',
        outputFormatType: 'BRO_SAD_IMBRO_XML_Correction',
        outputVersion: '1.0',
        preExportChecks: ['BROSADIdCheck', 'BROSADCorrectionReason'],
        Measurementpoints: true,
        AnalysisSamples: true,
        WaterSamples: true,
        AirSamples: true
      },
      {
        name: 'BROSAD_IMBROA_Registration_V2',
        exportTypeName: 'BRO_SAD_IMBRO_A',
        backend: 'importExportOrchestrator',
        outputFormatType: 'BRO_SAD_IMBROA_XML_Registration',
        outputVersion: '1.0',
        preExportChecks: ['BROSADIdCheck'],
        Measurementpoints: true,
        AnalysisSamples: true,
        WaterSamples: true,
        AirSamples: true
      },
      {
        name: 'BROSAD_IMBROA_Correction_V2',
        exportTypeName: 'BRO_SAD_IMBRO_A_Correctie',
        backend: 'importExportOrchestrator',
        outputFormatType: 'BRO_SAD_IMBROA_XML_Correction',
        outputVersion: '1.0',
        preExportChecks: ['BROSADIdCheck', 'BROSADCorrectionReason'],
        Measurementpoints: true,
        AnalysisSamples: true,
        WaterSamples: true,
        AirSamples: true
      }
    ]
  },
  {
    group: 'DOV',
    options: [
      {
        name: 'DOV',
        exportTypeName: 'DOV',
        exportServerIdentifier: 'Export_DOV',
        extension: 'zip',
        Measurementpoints: true
      }
    ]
  },
  {
    group: 'Legacy',
    options: [
      {
        name: 'SIKB13',
        exportTypeName: 'SIKB_13_5_0',
        exportServerIdentifier: 'Export_IMSIKB_v13_5_0',
        Measurementpoints: true,
        AnalysisSamples: true,
        WaterSamples: true,
        AirSamples: true
      },
      {
        name: 'TIPDX',
        exportTypeName: 'TIPDX',
        exportServerIdentifier: 'Export_DELPHI_PARADOX',
        extension: 'zip',
        Measurementpoints: true
      },
      {
        name: 'TIDB',
        exportTypeName: 'TIDB',
        exportServerIdentifier: 'Export_DELPHI_DBASE',
        extension: 'zip',
        Measurementpoints: true
      },
      {
        name: 'GEF',
        exportTypeName: 'GEF',
        exportServerIdentifier: 'Export_DELPHI_GEF',
        extension: 'zip',
        Measurementpoints: true
      }
    ]
  }
]

export default exportItems
